/**
 *
 * ConfirmationDialog
 *
 */

import React, { memo, FunctionComponent, useState } from 'react';
import { useIntl } from 'react-intl';
import messages from './messages';
import { DialogActionsBar } from '@progress/kendo-react-dialogs';
import Button from '../Button/Button.component';
import { ConfirmationBtnText } from '../../app/constants';
import { StyledDelete } from '../../features/Settings/styles';
import { StyledDialog } from './styles';

interface IProps {
  bodyText: string;
  cancelBtnText?: ConfirmationBtnText;
  confirmBtnText?: ConfirmationBtnText;
  handleCancel: () => void;
  handleConfirm: () => void;
  hideConfirmBtn?: boolean;
  hideCancelBtn?: boolean;
}

const ConfirmationDialog: FunctionComponent<IProps> = ({
  bodyText,
  cancelBtnText = ConfirmationBtnText.NO,
  confirmBtnText = ConfirmationBtnText.YES,
  handleCancel,
  handleConfirm,
  hideConfirmBtn,
  hideCancelBtn,
}) => {
  const intl = useIntl();
  const [btnMapText] = useState<Record<ConfirmationBtnText, string>>({
    [ConfirmationBtnText.YES]: intl.formatMessage(messages.yes),
    [ConfirmationBtnText.NO]: intl.formatMessage(messages.no),
    [ConfirmationBtnText.CANCEL]: intl.formatMessage(messages.cancel),
    [ConfirmationBtnText.OK]: intl.formatMessage(messages.ok),
  });

  return (
    <StyledDialog>
      <p>{bodyText}</p>
      <DialogActionsBar>
        {!hideCancelBtn && (
          <Button warn className={StyledDelete} onClick={handleCancel}>
            {btnMapText[cancelBtnText]}
          </Button>
        )}
        {!hideConfirmBtn && (
          <Button
            primary
            onClick={() => {
              handleConfirm();
              handleCancel();
            }}
          >
            {btnMapText[confirmBtnText]}
          </Button>
        )}
      </DialogActionsBar>
    </StyledDialog>
  );
};

export default memo(ConfirmationDialog);
